enum EFulfillmentAllsoftHTTPMethod {
  POST_JSON = 'post_json',
  GET = 'get',
}

export default EFulfillmentAllsoftHTTPMethod;
